var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarZoomLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150",
      fill: "white"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.1,48.7c-1.7-1.5-9,3.1-10.1,3.9c2.2-1.6-2-0.9-3.4-1.1c-1.5-0.3-3-0.8-4.4-1.4c-3.7-1.6-6.8-4.3-9.3-7.4 c-4.6-5.5-7.4-12.2-11.3-18.2c-3.7-5.6-8.2-10.2-14.4-13c-6.3-2.9-13.4-4-18.3-9.3c-2.5-2.7-16,5.2-15.1,8.7 C47,40.8,51.4,71.5,52,102.4c-16.7-0.9-40.2,13-32.7,32.2c6.9,17.4,32.7,17.7,43.6,4.2c5.5-6.8,3.9-19,4.1-27.3 c0.3-11.3,0.1-22.7-0.6-34c-1.2-19-3.9-37.9-7.9-56.5c0.5,0.2,1,0.5,1.4,0.7c9.2,4.9,13.2,14.5,18.3,22.9 c4.5,7.4,10.5,14.6,19.5,16.3c8.5,1.6,16.8-1.8,23.5-6.7C122.7,53.3,127.1,50.6,125.1,48.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M93.3,71.1v16.6c0,0.3-0.3,0.6-0.6,0.6l-16.2-0.1c-0.5,0-0.8-0.7-0.4-1l16.2-16.4C92.6,70.3,93.3,70.5,93.3,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,82.9v26.7c0,0.6-0.4,1-1,1l-26-0.2c-0.9,0-1.3-1.1-0.7-1.7l26-26.5C111.5,81.5,112.6,82,112.6,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.1,103.1v26.7c0,0.6-0.4,1-1,1l-26-0.2c-0.9,0-1.3-1.1-0.7-1.7l26-26.5C131.1,101.8,132.1,102.2,132.1,103.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarZoomLine);
export default __webpack_public_path__ + "static/media/SidebarZoomLine.556eb28e1af0bc6038d0da9069efec88.svg";
export { ForwardRef as ReactComponent };